import { get } from 'lodash-es';

export const localStorageMiddleware = ({ getState }) => next => action => {
  const result = next(action);
  try {
    // Don't persist state if user is being logged out
    const state = getState();
    if (!state || !state.get) return result;
    
    const stateJS = state.toJS();
    localStorage.setItem(
      'applicationState',
      JSON.stringify({
        appointment: get(stateJS, 'appointment'),
        therapist: get(stateJS, 'therapist'),
        user: get(stateJS, 'user'),
        membership: get(stateJS, 'membership'),
        gift: get(stateJS, 'gift'),
        preferences: get(stateJS, 'preferences'),
      }),
    );
  } catch (e) {
    // ignore for now
  }
  return result;
};

export const loadState = () => {
  try {
    // Check if user is authenticated before loading persisted state
    const userToken = localStorage.getItem('userToken') || getCookie('userToken');
    if (!userToken) {
      // User not authenticated, don't load stale state
      return undefined;
    }
    
    const serializedState = localStorage.getItem('applicationState');
    if (serializedState === null) {
      return undefined;
    }
    return JSON.parse(serializedState);
  } catch (err) {
    return undefined;
  }
};

// Helper function to get cookie value
function getCookie(name) {
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);
  if (parts.length === 2) return parts.pop().split(';').shift();
  return null;
}
